// src/components/TeachingPlanCard/Journey2DUtils.js

export const FRAMEWORK_COLORS = {
    EDU: { id: "EDU", bg: "#ffebee", main: "#c62828", label: "Education" },
    EID: { id: "EID", bg: "#fff8e1", main: "#f9a825", label: "Ethics" },
    GOV: { id: "GOV", bg: "#e8f5e9", main: "#2e7d32", label: "Governance" },
    TEC: { id: "TEC", bg: "#e3f2fd", main: "#1565c0", label: "Tech Design" },
    DEFAULT: { id: "DEFAULT", bg: "#f5f5f5", main: "#757575", label: "Other" },
};

export const FRAMEWORK_ORDER = ["EDU", "EID", "TEC", "GOV"]; // new 2x2 order
export const DIFFICULTY_LEVELS = [
    { id: "beg", label: "Beginner" },
    { id: "int", label: "Intermediate" },
    { id: "adv", label: "Advanced" },
];

/**
 * Parses an MLU code and returns { prefix, difficultyId, config }
 * E.g., "TEC-101" -> prefix: "TEC", difficultyId: "beg"
 */
export function parseMluCode(code) {
    const safeCode = (code || "").trim().toUpperCase();
    const prefix = safeCode.substring(0, 3);
    const config = FRAMEWORK_COLORS[prefix] || FRAMEWORK_COLORS.DEFAULT;

    let difficultyId = "beg"; // default

    // Extract all digits from the code (e.g. TEC-104 -> "104")
    const numbers = safeCode.match(/\d+/g);
    if (numbers && numbers.length > 0) {
        const lastNumStr = numbers[numbers.length - 1]; // "104"
        if (lastNumStr.length > 0) {
            // Get the strictly last digit
            const lastDigit = parseInt(lastNumStr.charAt(lastNumStr.length - 1), 10);
            if (lastDigit === 1 || lastDigit === 2) difficultyId = "beg";
            else if (lastDigit === 3 || lastDigit === 4) difficultyId = "int";
            else if (lastDigit === 5 || lastDigit === 6 || lastDigit > 6) difficultyId = "adv";
        }
    }

    return { prefix, difficultyId, config };
}
